import Swal from "sweetalert2";
import axios from "./axiosHelper";

export default class {
  constructor(options) {
    this.options = options;
    this.showLoading();
    this.sendData();
  }

  showLoading() {
    Swal.fire({
      title: "Mohon tunggu sebentar :)",
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false
    });
  }

  sendData() {
    const {
      url,
      data,
      successTitle,
      successMessage,
      successCallback
    } = this.options;

    axios
      .post(url, data)
      .then(result => {
        Swal.fire({
          title: successTitle,
          text: successMessage,
          type: "success",
          confirmButtonColor: "#559fd6",
          onClose: () => {
            if (successCallback) successCallback();
          }
        });
      })
      .catch(err => {
        this.showErrorPopup(err.response);
      });
  }

  showErrorPopup(errorData) {
    let errorTitle;
    let errorMessage = "";

    if (errorData.status == 422) {
      errorTitle = "Tolong isi data dengan benar!";

      // errorData.data.error.forEach(error => {
      //   errorMessage += `<div>- ${error}</div>`;
      // });
    } else {
      errorTitle = "Ada sesuatu yang bermasalah!";
      console.log(errorData);
    }

    Swal.fire({
      title: errorTitle,
      html: errorMessage,
      type: "error",
      confirmButtonColor: "#559fd6",
      confirmButtonText: "Coba lagi"
    });
  }
}
